import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

import { gql } from '../../../../../__generated__/graphql/catalog'
import { reportClientError } from '../../../../../app/_components/chrome/scripts/DataDogRumScript'
import { useFetchNostoPlacementData } from '../../../../../app/_hooks/useFetchNostoPlacementData'
import { ProductWithAvailability } from '../../../../../types/graphql'

export const FETCH_COMPLETE_THE_SET_NOSTO = gql(`
  query FetchCompleteTheSetNosto($handles: [String!]) {
    products(handles: $handles) {
      nodes {
        __typename
        id
        handle
        color
        colorInfo {
          name
          rawName
        }
        category
        images(first: 1) {
          nodes {
            source
          }
        }
        productGroup {
          id
          colorGroups {
            ...ColorGroup
          }
          colors {
            availability
            hexCodes
            name
            rawName
            swatchUrl
          }
          defaultVariant {
            priceDetails {
              discountPrice {
                amount
              }
              price {
                amount
              }
            }
          }
          description
          fits
          handle
          productsForAvailability: products {
            availableSizes
            colorInfo {
              rawName
            }
            rawFit
            swPromoEligible
          }
          rawFits
          sizes
          style
          sizeChart: sizeChartCG {
            ...SizeChartFragment
          }
        }
        defaultVariant {
          __typename
          shopifyId
          sku
          handle
          size
          soldOut
          priceDetails {
            price {
              amount
              currency
            }
            discountPrice {
              amount
            }
          }
        }
        variants {
          __typename
          shopifyId
          sku
          handle
          size
          soldOut
          priceDetails {
            price {
              amount
              currency
            }
            discountPrice {
              amount
            }
          }
        }
      }
    }
  }
`)

const useFetchDefault = (skip: boolean) => {
  const nostoPlacementId = 'productpage-nosto-1'
  const {
    data: { productHandles },
    status: nostoStatus,
  } = useFetchNostoPlacementData(nostoPlacementId)

  const [fetchNostoProductDetails, { data, loading }] = useLazyQuery<{
    products: { nodes?: ProductWithAvailability[] }
  }>(FETCH_COMPLETE_THE_SET_NOSTO, {
    onError: error => {
      reportClientError({
        error,
        context: {},
      })
    },
  })

  useEffect(() => {
    if (productHandles && productHandles.length > 0 && skip) {
      fetchNostoProductDetails({
        variables: { handles: productHandles[0] },
      })
    }
  }, [fetchNostoProductDetails, productHandles, skip])

  const product = data?.products?.nodes ? data?.products?.nodes[0] : undefined

  return {
    product,
    loading: loading || nostoStatus === 'pending',
  }
}

export default useFetchDefault
